import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useAsyncEffect } from '@xylabs/sdk-react'
import BigNumber from 'bn.js'
import { useContext, useState } from 'react'

import { CurrencyBalanceContext, CurrencyContext, useGeotoken } from '../Contexts'
import { parseBigNumber } from '../parseBigNumber'
import { shiftBase10 } from '../shiftBase10'
import XyoTextField from './XyoTextField'

interface DepositDialogProps {
  onClose?: () => void
  open?: boolean
}

const DepositDialogOpen: React.FC<DepositDialogProps> = (props) => {
  const { onClose, open = false } = props
  const geotoken = useGeotoken()
  const { erc20 } = useContext(CurrencyContext)
  const { balance } = useContext(CurrencyBalanceContext)
  const [amount, setAmount] = useState(shiftBase10(balance, -1)?.toString() ?? '0')

  const onDepositClicked = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    const erc20Address = erc20?.getAddress()
    if (erc20Address) {
      await geotoken?.geotoken?.depositErc20(erc20Address, shiftBase10(parseBigNumber(amount), 18) ?? new BigNumber(0))
    }
    onClose?.()
  }

  const [tokenBalance, setTokenBalance] = useState<BigNumber | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const data = await geotoken?.getBalance()
      if (!isMounted()) return
      setTokenBalance(data)
    },
    [geotoken],
  )

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const amount = shiftBase10(parseBigNumber(event.target.value), 18)
    setAmount(shiftBase10(amount, -18)?.toString() ?? '0')
  }

  return (
    <Dialog
      onClose={() => {
        onClose?.()
      }}
      open={open}
    >
      <DialogTitle>Deposit to Geotoken</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column">
          <Box display="flex" width="100%">
            <Typography variant="body1">Please select how much you want to deposit</Typography>
          </Box>
          <Box padding={1}>
            <XyoTextField fullWidth label="Current Balance" readOnly value={shiftBase10(tokenBalance, -18)?.toString() ?? '-'} variant="outlined" />
          </Box>
          <Box padding={1}>
            <XyoTextField fullWidth label="Deposit Amount" onChange={onChange} value={amount ?? '0'} variant="outlined" />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" width="100%">
          <Box>
            <Button
              onClick={() => {
                onClose?.()
              }}
              variant="text"
            >
              Close
            </Button>
          </Box>
          <Box flexGrow={1}></Box>
          <Box>
            <Button onClick={onDepositClicked} variant="text">
              Deposit
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

const DepositDialog: React.FC<DepositDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <DepositDialogOpen {...props} />
  } else {
    return null
  }
}

export default DepositDialog
